import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Button from '../../button/index';
import { DARK } from '../../button/variants';
import messages from '../messages';
import css from '../index.scss';

const RollOverSelection = (props) => {
    const {
        intl,
        isFullRollover,
        isPartialRollover,
        rollOverIsFull,
        rollOverIsPartial,
        selectedProduct,
        showHelpModal,
        showInitialPage,
        showUploadPage
    } = props;

    const isPartialActive = isPartialRollover ? css.rollOverPartialIsActive : '';
    const isFullActive = isFullRollover ? css.rollOverFullIsActive : '';
    return (<div className={css.rollOverComponent}>
        <div className={css.header}>
            <div className={css.title}>{intl.formatMessage(messages.header)}</div>
        </div>
        <div className={css.content}>
            <div className={css.contentWrapper}>
                <div className={css.contentLabel}>{intl.formatMessage(messages.selectionTitle)} <Button
                    buttonContainer={css.helpButtonContainer}
                    containerClassName={css.helpButton}
                    handleOnClick={showHelpModal}
                    label={intl.formatMessage(messages.buttonIcon)} /></div>
                <div className={css.contentBody}>
                    <div className={css.selectionContainer}>
                        <Button
                            containerClassName={`${css.selectionItem} ${isPartialActive}`}
                            handleOnClick={rollOverIsPartial}>
                            <div className={css.selectionItemContent}>
                                <h2>
                                    {intl.formatMessage(messages.partialRolloverTitle)}
                                </h2>
                                <p>
                                    {intl.formatMessage(messages.partialRolloverDesc1, { productName: selectedProduct.name })}
                                </p>
                                <p>
                                    {intl.formatMessage(messages.partialRolloverDesc2)}
                                </p>
                            </div>
                        </Button>
                        <Button
                            containerClassName={`${css.selectionItem} ${isFullActive}`}
                            handleOnClick={rollOverIsFull}>
                            <div className={css.selectionItemContent}>
                                <h2>
                                    {intl.formatMessage(messages.fullRolloverTitle)}
                                </h2>
                                <p>
                                    {intl.formatMessage(messages.fullRolloverDesc1, { productName: selectedProduct.name })}
                                </p>
                                <p>
                                    {intl.formatMessage(messages.fullRolloverDesc2, { productName: selectedProduct.name })}
                                </p>
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
        <div className={css.rollOverFooter}>
            <Button disabled={!isFullRollover && !isPartialRollover} handleOnClick={showUploadPage} label={intl.formatMessage(messages.nextButton)} variant={DARK} />
            <Button handleOnClick={showInitialPage} label={intl.formatMessage(messages.backButton)} variant={DARK} />
        </div>
    </div>);
};

RollOverSelection.propTypes = {
    intl: intlShape.isRequired,
    isFullRollover: PropTypes.bool,
    isPartialRollover: PropTypes.bool,
    rollOverIsFull: PropTypes.func,
    rollOverIsPartial: PropTypes.func,
    selectedProduct: PropTypes.object,
    showHelpModal: PropTypes.func,
    showInitialPage: PropTypes.func,
    showUploadPage: PropTypes.func
};

export default injectIntl(styleable(css)(RollOverSelection));



// WEBPACK FOOTER //
// ./app/components/roll-over/pages/selection.js